import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CheckEmailForm from '../../../forms/CheckEmailForm';
import Separator from '../../../common/Separator';
import SocialsLogin from '../../SocialsLogin';
import SignInPolicyDescription from '../../SignInPolicyDescription';
import DeepLinkLoginPreview from '../../../deepLink/DeepLinkLoginPreview';

const CheckEmailStep: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <DeepLinkLoginPreview />
      <CheckEmailForm />
      <Separator text={t('or')} />
      <SocialsLogin />
      <SignInPolicyDescription />
    </>
  );
};

export default CheckEmailStep;
